<template>
  <node-view-wrapper as="span" class="image-container">
    <div
      v-if="node.attrs.link"
      :title="node.attrs.link"
      class="w-full h-full text-white bg-black bg-opacity-50 absolute left-0 top-0 flex items-center justify-center"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="currentColor"
        class="w-10 h-10"
      >
        <path
          fill-rule="evenodd"
          d="M19.902 4.098a3.75 3.75 0 00-5.304 0l-4.5 4.5a3.75 3.75 0 001.035 6.037.75.75 0 01-.646 1.353 5.25 5.25 0 01-1.449-8.45l4.5-4.5a5.25 5.25 0 117.424 7.424l-1.757 1.757a.75.75 0 11-1.06-1.06l1.757-1.757a3.75 3.75 0 000-5.304zm-7.389 4.267a.75.75 0 011-.353 5.25 5.25 0 011.449 8.45l-4.5 4.5a5.25 5.25 0 11-7.424-7.424l1.757-1.757a.75.75 0 111.06 1.06l-1.757 1.757a3.75 3.75 0 105.304 5.304l4.5-4.5a3.75 3.75 0 00-1.035-6.037.75.75 0 01-.354-1z"
          clip-rule="evenodd"
        />
      </svg>
    </div>

    <img
      v-bind="node.attrs"
      ref="resizableImg"
      :draggable="isDraggable"
      :data-drag-handle="isDraggable"
    />

    <div ref="icon" class="resize-icon" @mousedown="onMouseDown">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 20 20"
        fill="currentColor"
        class="w-4 h-4 text-white"
      >
        <path
          d="M6.28 5.22a.75.75 0 00-1.06 1.06l7.22 7.22H6.75a.75.75 0 000 1.5h7.5a.747.747 0 00.75-.75v-7.5a.75.75 0 00-1.5 0v5.69L6.28 5.22z"
        />
      </svg>
    </div>
  </node-view-wrapper>
</template>

<script>
import { NodeViewWrapper, nodeViewProps } from '@tiptap/vue-2'

export default {
  components: {
    NodeViewWrapper,
  },

  props: nodeViewProps,

  data: () => ({
    isResizing: false,
    lastMovement: {},
    count: 0,
  }),

  computed: {
    isDraggable() {
      return this.node?.attrs?.isDraggable
    },
  },

  methods: {
    onMouseDown(e) {
      e.preventDefault()
      this.isResizing = true
      window.addEventListener('mousemove', this.throttle(this.onMouseMove))
      window.addEventListener('mouseup', this.onMouseUp)
    },

    onMouseUp() {
      // e.preventDefault()
      this.isResizing = false
      this.lastMovement = {}
      window.removeEventListener('mousemove', this.throttle(this.onMouseMove))
      window.removeEventListener('mouseup', this.onMouseUp)
    },

    throttle(fn, wait = 60, leading = true) {
      let prev, timeout, lastargs
      return (...args) => {
        lastargs = args
        if (timeout) {
          return
        }

        timeout = setTimeout(
          () => {
            timeout = null
            prev = Date.now()
            // let's do this ... we'll release the stored args as we pass them through
            fn.apply(this, lastargs.splice(0, lastargs.length))
            // some fancy timing logic to allow leading / sub-offset waiting periods
          },

          leading ? (prev && Math.max(0, wait - Date.now() + prev)) || 0 : wait,
        )
      }
    },

    onMouseMove(e) {
      e.preventDefault()

      if (!this.isResizing) {
        return
      }

      if (!Object.keys(this.lastMovement).length) {
        this.lastMovement = { x: e.x, y: e.y }
        return
      }

      if (e.x === this.lastMovement.x && e.y === this.lastMovement.y) {
        return
      }

      let nextX = e.x - this.lastMovement.x
      let nextY = e.y - this.lastMovement.y
      const width = this.$refs.resizableImg.width + nextX
      const height = this.$refs.resizableImg.height + nextY
      this.lastMovement = { x: e.x, y: e.y }
      this.updateAttributes({ width, height })
    },
  },
}
</script>

<style lang="scss" scoped>
.image-container {
  overflow: hidden;
  position: relative;
  display: inline-block;
  margin: 0.25rem;

  img {
    margin: 0;
  }
}

.resize-icon {
  position: absolute;
  bottom: 2px;
  right: 2px;
}

::v-deep.resize-icon {
  cursor: se-resize !important;
}
</style>
